import { Injectable } from '@angular/core';
import { Observable, of, catchError } from 'rxjs';
import { ServiceBase } from './servicebase.service';

@Injectable({
  providedIn: 'root'
})
export class EventService extends ServiceBase {
  public getEventByStagingId(eventStagingId: string): Observable<ServerModels.ENESS_EventDTO> {
    let options = {
      headers: this.httpOptions.headers,
      params: {
        'eventStagingId': eventStagingId
      }
    };
    return this.http.get<ServerModels.ENESS_EventDTO>(`${this.apiRoot}/api/Events/GetEventByStagingId`, options).pipe(catchError(this.swallowError<any>('getEventByStagingId', 'defaultMsg', null, null))); 
  }

  public createOrUpdateEvent(eventIds: any): Observable<string> {
    return this.http.post<string>(`${this.apiRoot}/api/Events/CreateOrUpdateEvent`, eventIds, this.httpOptions).pipe(catchError(this.throwError<any>('CreateOrUpdateEvent', null, null, null))); 
  }

  public addOrUpdateEventDetailsStagingAsync(eventDto: ServerModels.ENESS_EventDTO): Observable<ServerModels.ENESS_EventDTO> {
    return this.http.post<ServerModels.ENESS_EventDTO>(`${this.apiRoot}/api/Events/AddOrUpdateEventDetailsStagingAsync`, eventDto, this.httpOptions).pipe(catchError(this.throwError<any>('addOrUpdateEventDetailsStagingAsync', null, null, null))); 
  }

  public addOrUpdateEventLEPartner(partner: ServerModels.ENESS_XREF_EventsLEPartnersDTO): Observable<ServerModels.ENESS_XREF_EventsLEPartnersDTO> {
    return this.http.post<ServerModels.ENESS_XREF_EventsLEPartnersDTO>(`${this.apiRoot}/api/Events/AddOrUpdateEventLEPartner`, partner, this.httpOptions).pipe(catchError(this.throwError<any>('addOrUpdateEventLEPartner', null, null, null)));
  }

  public copyEventLEPartnerToStaging(partner: ServerModels.ENESS_XREF_EventsLEPartnersDTO): Observable<ServerModels.ENESS_XREF_EventsLEPartnersDTO> {
    return this.http.post<ServerModels.ENESS_XREF_EventsLEPartnersDTO>(`${this.apiRoot}/api/Events/CopyEventLEPartnerToStaging`, partner, this.httpOptions).pipe(catchError(this.throwError<any>('copyEventLEPartnerToStaging', null, null, null)));
  }

  public deleteEventLEPartner(eventLEPartnerStagingId: string): Observable<number> {
    return this.http.post<number>(`${this.apiRoot}/api/Events/DeleteEventLEPartnerStaging`, JSON.stringify(eventLEPartnerStagingId), this.httpOptions).pipe(catchError(this.throwError<any>('deleteEventLEPartner', null, null, null)));
  }

  public addOrUpdateEventLocationStaging(eventLocationDTO: ServerModels.ENESS_XREF_EventsLocationsDTO): Observable<ServerModels.ENESS_XREF_EventsLocationsDTO> {
    return this.http.post<ServerModels.ENESS_XREF_EventsLocationsDTO>(`${this.apiRoot}/api/Events/AddOrUpdateEventLocationStaging`, eventLocationDTO, this.httpOptions).pipe(catchError(this.throwError<any>('addOrUpdateEventLocationStaging', null, null, null)));
  }

  public addExistingEventLocationsToStaging(eventLocationDTOs: ServerModels.ENESS_XREF_EventsLocationsDTO[]): Observable<ServerModels.ENESS_XREF_EventsLocationsDTO[]> {
    return this.http.post<ServerModels.ENESS_XREF_EventsLocationsDTO[]>(`${this.apiRoot}/api/Events/AddExistingEventsLocationsToStaging`, eventLocationDTOs, this.httpOptions).pipe(catchError(this.throwError<any>('addExistingEventLocationsToStaging', null, null, null)));
  }

  public uploadEventAttachmentsStaging(formData: FormData): Observable<ServerModels.ENESS_XREF_EventAttachmentsDTO[]> {
    return this.http.post<ServerModels.ENESS_XREF_EventAttachmentsDTO[]>(`${this.apiRoot}/api/Events/UploadEventAttachmentsStaging`, formData, this.httpFormData).pipe(catchError(this.throwError<any>('uploadEventAttachmentsStaging', 'defaultMsg', null, null)));
  }

  public deleteEventLocationStaging(eventLocationStagingId: string): Observable<number> {
    let options = {
      params: {
        'eventLocationStagingId': eventLocationStagingId
      },
      headers: this.httpOptionsText.headers
    };
    return this.http.get<string>(`${this.apiRoot}/api/Events/DeleteEventLocationStaging`, options).pipe(catchError(this.swallowError<any>('deleteEventLocationStaging', 'defaultMsg', null, null)));
  }

  public deleteEventAttachmentStaging(attachmentStagingId: string): Observable<number> {
    return this.http.post<number>(`${this.apiRoot}/api/Events/DeleteEventAttachmentsStaging`, JSON.stringify(attachmentStagingId), this.httpOptions).pipe(catchError(this.swallowError<any>('DeleteEventAttachmentsStaging', 'defaultMsg', null, null))); 
  }

  public editUploadedEventById(eventStagingId: string, eventImportId: string): Observable<ServerModels.ENESS_EventDTO> {
    let options = {
      params: {
        'eventStagingId': eventStagingId,
        'eventImportId': eventImportId
      },
      headers: this.httpOptions.headers
    };
    return this.http.get<ServerModels.ENESS_EventDTO>(`${this.apiRoot}/api/Events/EditUploadedEventById`, options).pipe(catchError(this.swallowError<any>('editUploadedEventById', 'defaultMsg', null, null))); 
  }

  public generateEventStagingId(): Observable<string> {
    return this.http.get<string>(`${this.apiRoot}/api/Events/GetNewEventStagingID`, this.httpOptions).pipe(catchError(this.swallowError<any>('generateEventId', 'defaultMsg', null, null))); 
  }

  public getAllEventsViewModel(filters: ServerModels.FiltersViewModel): Observable<ServerModels.EventViewModel[]> {
    let headersObj = this.httpOptions.headers.append('Skip-Loader', 'true');
    let options = {
      headers: headersObj
    };
    return this.http.post<ServerModels.EventViewModel[]>(`${this.apiRoot}/api/Events/AllEventsViewModelPaged`, filters, options).pipe(catchError(this.throwError<any>('getAllEventsViewModel', null, null, null)));;
  }

  public getAttachmentById(eventId: string, attachmentId: string): any {
    let options = {
      responseType: 'blob' as 'json',
      params: {
        eventId: eventId,
        attachmentId: attachmentId
      }
    };
    return this.http.get<Blob>(`${this.apiRoot}/api/Events/GetAttachmentById`, options).pipe(catchError(this.throwError<any>('getAttachmentById', 'defaultMsg', null, null)));
  }

  public getEventById(eventId: string): Observable<ServerModels.EventDataModel> {
    return this.http.get<ServerModels.EventDataModel>(`${this.apiRoot}/api/Events/GetEventByID?eventId=${eventId}`, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('getEventById', 'defaultMsg', null, null))); 
  }

  public getEditEventDTOById(eventStagingId: string, eventId: string): Observable<ServerModels.ENESS_EventDTO> {
    let options = {
      headers: this.httpOptions.headers,
      params: {
        eventStagingId: eventStagingId,
        eventId: eventId
      }
    };

    return this.http.get<ServerModels.ENESS_EventDTO>(`${this.apiRoot}/api/Events/GetEditEventDTOByID`, options)
      .pipe(catchError(this.swallowError<any>('getEditEventDTOById', 'defaultMsg', null, null))); 
  }

  public setEventStagingData(eventId: string): Observable<string> {
    return this.http.get(`${this.apiRoot}/api/Events/SetEventStagingDataByRMS?eventId=${eventId}`, { responseType: 'text' })
      .pipe(catchError(this.swallowError<any>('SetEventStagingDataByRMS', 'defaultMsg', null, null))); 

  }

  public getEventDataModelById(eventId: string): Observable<ServerModels.ENESS_EventDTO> {
    return this.http.get<ServerModels.ENESS_EventDTO>(`${this.apiRoot}/api/Events/GetEventByID?eventId=${eventId}`, this.httpNoCache).pipe(catchError(this.swallowError<any>('getEventDataModelById', 'defaultMsg', null, null)));
  }

  public getImportStatus(): Observable<ServerModels.ImportStatus[]> {
    return this.http.get<ServerModels.ImportStatus[]>(`${this.apiRoot}/api/Events/GetImportStatus`, this.httpOptions).pipe(catchError(this.swallowError<any>('getImportStatus', 'defaultMsg', null, null))); 
  }

  public getNarrativeById(eventId: string): Observable<string> {
    return this.http.get<string>(`${this.apiRoot}/api/Events/GetNarrativeById`, {
      headers: this.httpOptions['headers'],
      params: {
        eventId: eventId
      }
    }).pipe(catchError(this.swallowError<any>('getNarrativeById', 'defaultMsg', null, null))); 
  }

  public getUploadedEventById(itemId: string): Observable<ServerModels.ENESS_EventDTO> {
    return this.http.get<ServerModels.ENESS_EventDTO>(`${this.apiRoot}/api/Events/GetUploadedEventById`, {
      headers: this.httpOptions['headers'],
      params: {
        itemId: itemId
      }
    }).pipe(catchError(this.swallowError<any>('getUploadedEventById', 'defaultMsg', null, null)));
  }

  public getUploadResult(): Observable<ServerModels.ENESS_ImportItem[]> {
    return this.http.get<ServerModels.ENESS_ImportItem[]>(`${this.apiRoot}/api/Events/GetUploadFailedItems`, this.httpOptions).pipe(catchError(this.swallowError<any>('getUploadResult', 'defaultMsg', null, null)));
  }

  public markImportItemIsFixedAsync(itemId: string): Observable<any> {
    if (!itemId)
      return of(null);

    return this.http.post(`${this.apiRoot}/api/Events/MarkImportItemIsFixedAsync`, JSON.stringify(itemId), this.httpOptions).pipe(catchError(this.swallowError<any>('markImportItemIsFixedAsync', 'defaultMsg', null, null))); 
  }

  public addOrUpdateEventPersonStaging(eventPersonDTO: ServerModels.ENESS_XREF_EventsPeopleDTO): Observable<ServerModels.ENESS_XREF_EventsPeopleDTO> {
    return this.http.post<ServerModels.ENESS_XREF_EventsPeopleDTO>(`${this.apiRoot}/api/Events/AddOrUpdateEventPersonStaging`, eventPersonDTO, this.httpOptions)
      .pipe(catchError(this.throwError<any>('addOrUpdateEventPersonStaging', null, null, null))); 
  }

  public addOrUpdateEventPeopleTypesStaging(eventPeople: ServerModels.ENESS_XREF_EventsPeopleDTO): Observable<ServerModels.ENESS_XREF_EventsPeopleDTO> {
    return this.http.post<ServerModels.ENESS_XREF_EventsPeopleDTO>(`${this.apiRoot}/api/Events/AddOrUpdateEventPeopleTypesStaging`, eventPeople, this.httpOptions)
      .pipe(catchError(this.throwError<any>('addOrUpdateEventPeopleTypesStaging', null, null, null))); 
  }

  public copyEventPeopleToStaging(eventPeople: ServerModels.ENESS_XREF_EventsPeopleDTO[]): Observable<ServerModels.ENESS_XREF_EventsPeopleDTO[]> {
    return this.http.post<ServerModels.ENESS_XREF_EventsPeopleDTO[]>(`${this.apiRoot}/api/Events/CopyEventPeopleToStaging`, eventPeople, this.httpOptions)
      .pipe(catchError(this.throwError<any>('copyEventPeopleToStaging', null, null, null))); 
  }

  public deleteEventPeopleStaging(eventPersonStagingId: string): Observable<number> {
    return this.http.post<number>(`${this.apiRoot}/api/Events/DeleteEventPeopleStaging`, JSON.stringify(eventPersonStagingId), this.httpOptions)
      .pipe(catchError(this.throwError<any>('deleteEventPeopleStaging', null, null, null))); 
  }

  public hasEditPermission(eventId: string): Observable<boolean> {
    let options = {
      headers: this.httpOptions.headers,
      params: {
        'eventId': eventId
      }
    };
    return this.http.get<boolean>(`${this.apiRoot}/api/Events/HasPermissionToEditEvent`, options).pipe(catchError(this.swallowError<any>('hasEditPermission', 'defaultMsg', null, null))); 
  }
}
